/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Sl_Lot_Kg_ValueInputs */

const vi_sl_lot_kg_value = /** @type {(inputs: Sl_Lot_Kg_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.qty} kg`)
};

/**

* @param {Sl_Lot_Kg_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_kg_value = /** @type {((inputs: Sl_Lot_Kg_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_Kg_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_kg_value(inputs)
});